import type { ProductPublicResponse } from '@apm/contracts';
import { config } from './config.js';

/**
 * 상품 단건 조회 (`docs/08` §8 — T9 가 BLOOM Server 에 만든 유일한 엔드포인트).
 *
 * **상품의 제목·가격·썸네일은 TV2M 계약 어디에도 없다.** Deep Link 도 Deferred 응답도
 * `productId` 까지만 준다 — 매칭은 TV2M 의 일이고 상품은 BLOOM Server 의 것이라는 분리가
 * 그대로 드러난 자리다 (`docs/07` §3.1). 그래서 화면이 직접 부른다.
 *
 * **실패를 던지지 않고 `null` 로 돌려준다.** BLOOM Server 가 꺼져 있거나 상품이
 * `ready` 가 아니어도(그때 404 다) Deep Link 가 담고 있는 것 — 상품 id·쿠폰·유입
 * 경로 — 은 그대로 보여야 한다. 이 조회는 화면을 풍부하게 할 뿐 전환 경로의 조건이
 * 아니다.
 *
 * 인증이 없다(공개 엔드포인트). 쿠키도 싣지 않는다 — 실으면 BLOOM Server 의 CORS 가
 * `credentials: true` 라 오리진이 열거돼야 하는데, 여기서 필요한 것은 공개 조회뿐이다.
 */
export async function fetchProduct(
  productId: string,
  signal?: AbortSignal,
): Promise<ProductPublicResponse | null> {
  const base = config.serverUrl.replace(/\/+$/, '');
  try {
    const options = signal ? { signal } : {};
    const response = await fetch(`${base}/v1/products/${encodeURIComponent(productId)}`, options);
    if (!response.ok) return null;
    return (await response.json()) as ProductPublicResponse;
  } catch {
    return null;
  }
}
